import { IApiError } from '@/models/apiError.model';
import { IPhoto } from '@/models/photos.model';

export const PICTURES_SLICE_NAME = 'pictures';

export interface PictureState {
  propertyPhotosInside: IPhoto[] | null;
  propertyPhotosOutside: IPhoto[] | null;
  floorPlan: IPhoto[] | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: PictureState = {
  propertyPhotosInside: null,
  floorPlan: null,
  propertyPhotosOutside: null,
  isLoading: false,
  error: null,
};
